import { AbridgedInvoiceMetadataWithAmountDue, InvoiceV2Status, isNullish } from '@breezy/shared'
import { useMemo } from 'react'
import { mapInvoiceToAbridgedInvoiceMetadata, useFetchInvoicesSubscription } from '../../pages/Invoices/invoiceUtils'

type AbridgedInvoiceMetadataLoaderReturn = {
  invoice?: AbridgedInvoiceMetadataWithAmountDue
  loading: boolean
}

export const useFetchAbridgedInvoiceByMaintenancePlanGuid = ({
  maintenancePlanGuid,
  pause,
  status,
}: {
  maintenancePlanGuid: string
  pause?: boolean
  status?: InvoiceV2Status
}): AbridgedInvoiceMetadataLoaderReturn => {
  const whereClause = useMemo(() => {
    const baseWhere = {
      maintenancePlanLink: {
        maintenancePlanGuid: {
          _eq: maintenancePlanGuid,
        },
      },
    }

    // Only include status filter if status is defined
    if (!isNullish(status)) {
      return {
        ...baseWhere,
        status: {
          _eq: status,
        },
      }
    }

    return baseWhere
  }, [maintenancePlanGuid, status])

  const res = useFetchInvoicesSubscription(whereClause, pause)

  const rawInvoice = res.data && (res.data.invoices?.length ?? 0) > 0 ? res.data.invoices[0] : undefined
  const invoice = rawInvoice ? mapInvoiceToAbridgedInvoiceMetadata(rawInvoice.invoiceGuid, rawInvoice) : undefined

  return {
    invoice,
    loading: res.fetching,
  }
}
